exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(/src/assets/style/style.css);", ""]);

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6662cb4a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/grave_guide.vue
// module id = 207
// module chunks = 1